import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Research from './pages/Research';
import Projects from './pages/Projects';
import Publications from './pages/Publications';
import Contact from './pages/Contact';
import Header from './components/Header';

import WarmStone from './pages/projects/WarmStone';
import BioMirror from './pages/projects/BioMirror';
import HeartCalligraphy from './pages/projects/HeartCalligraphy';
import HeartBloom from './pages/projects/HeartBloom';
import ScrollToTop from "./components/ScrollToTop";

import './App.css'; // make sure this is imported


function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
      <div className="content-wrapper">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/research" element={<Research />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/contact" element={<Contact />} />
        {/* Individual project page */}
        <Route path="/projects/warmstone" element={<WarmStone />} />
        <Route path="/projects/biomirror" element={<BioMirror />} />
        <Route path="/projects/heartcalligraphy" element={<HeartCalligraphy />} />
        <Route path="/projects/heartbloom" element={<HeartBloom />} />  

      </Routes>
      </div>
    </Router>
  );
}

export default App;


